const defineLang = () => {
  const url = window.location.href;
  if (url.includes('/sv')) return 'sv';
  return 'fi';
};

export default defineLang;
